import {EAdviceType} from './definitions';

export default {
  ednaAdvices: 'edna tips',
  more: {
    [EAdviceType.WA_QUALITY_CHANNELS]: '<0>View more recommendations</0>',
    [EAdviceType.WA_QUALITY_CHANNEL]: '<0>View more recommendations</0>',
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]: '<0>View more recommendations</0>',
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]: '<0>View more recommendations</0>',
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]: '<0>View more recommendations</0>',
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]: '<0>View more recommendations</0>',
    [EAdviceType.WA_CHANNEL_VERIFICATION]:
      '[en] Чтобы подготовиться к верификации, ознакомьтесь <0>с нашим руководством.</0>',
    [EAdviceType.MAX_BLOCKING_PROTECTION]: '<0>More tips here</0>',
  },
  closeModal: {
    title: 'Hide this tip permanently?',
    subtitle:
      'You won’t see this tip here again, but it will remain available in the documentation.',
  },
  description: {
    [EAdviceType.WA_CHANNEL_VERIFICATION]:
      'Business verification confirms that your company is a legitimate and registered organization. Once verified, you’ll unlock advanced features in WhatsApp:',
  },
  title: {
    [EAdviceType.WA_QUALITY_CHANNELS]: 'How to avoid WhatsApp channel blocking',
    [EAdviceType.WA_QUALITY_CHANNEL]: 'How to maintain WhatsApp channel quality and limits',
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]:
      'How to create a campaign to avoid WhatsApp channel blocking',
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]:
      'How to create a campaign to avoid WhatsApp channel blocking',
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]:
      'How to create a template to avoid WhatsApp channel blocking',
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]:
      'How to create a template to avoid WhatsApp channel blocking',
    [EAdviceType.WA_CHANNEL_VERIFICATION]: 'Why business verification is needed in Meta',
    [EAdviceType.MAX_BLOCKING_PROTECTION]: 'How to make MAX a trusted channel and prevent blocks',
  },
  points: {
    [EAdviceType.WA_QUALITY_CHANNELS]: [
      'Use numbers that have been registered with WhatsApp for a long time. Older numbers have lower risk of being blocked.',
      'Wait at least 24 hours before using a new number for messaging. Limit new contacts to 20 per day during the first 10 days.',
      'Maintain a high rate of incoming messages. Aim for at least 30% of recipients to reply. Add questions to encourage responses.',
    ],
    [EAdviceType.WA_QUALITY_CHANNEL]: [
      'Aim for a high message read rate of at least 65%.',
      "If you're unsure whether recipients have your company’s WhatsApp number, send the campaign in batches of 10–15% of your contact base per hour.",
      'Send at least 50% of your current template message limit within 7 days to maintain or increase your limit.',
      'If your limit is reduced, distribute the load across multiple WhatsApp accounts to reduce the risk of further restrictions.',
    ],
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]: [
      'Don’t launch bulk campaigns right after connecting the number. Gradually increase the volume over the first few weeks.',
      'Send messages at appropriate times. Avoid late nights and early mornings on weekends.',
      'Avoid high-frequency messaging: no more than 1 message per minute and no longer than 8 hours straight.',
    ],
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]: [
      'Choose targeted, relevant audiences. Avoid random contact lists.',
      'Personalize messages: use the recipient’s name, include individual offers or specific details.',
      'Send messages only to recipients who have opted in.',
      'Test campaign on 50–150 contacts before sending it to a wider list.',
    ],
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]: [
      'Keep messages short and informative. Avoid lengthy texts.',
      'Create templates with clear and relevant content with appropriate keywords.',
      'Add personalization (recipient’s name) and explain why the recipient is getting this message.',
      'Make sure variables (names, dates, product names, etc.) are displayed correctly.',
    ],
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]: [
      'Provide a convenient opt-out option (“Stop” or “Unsubscribe” button).',
      'Include interactive elements such as buttons, emojis, and links.',
      'Test new templates on a small audience before launching a mass campaign. You can register and use test channels for this purpose.',
    ],
    [EAdviceType.WA_CHANNEL_VERIFICATION]: [
      'Higher messaging limits for all WhatsApp channels',
      'Display your business name instead of a phone number',
      'Ability to request the official verified badge (green checkmark)',
    ],
    [EAdviceType.MAX_BLOCKING_PROTECTION]: [
      'To prevent account blocking, avoid bulk messaging. New numbers may be blocked if they send more than 15 messages a day to new contacts.',
      'Do not start bulk messaging from new numbers right away. Build your contact base gradually.',
      'Sending the same message to all your contacts is the fastest way to get blocked.',
    ],
  },
};
